import { AddressType } from "../index.js";
export const getBillingAddress = (addresses) => {
    return addresses?.find((address) => address.type === AddressType.BILLING);
};
